<template>
  <div id="agreements" class="modal fade custom termsOfUse-wrapper" role="dialog">
    <div class="modal-dialog modal-lg termsOfUse-modal-dialog">
        <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
          <div class="close-icon-section">
              <img src="/static/images/icons/ul_close_icon.svg" class="close-icon" data-dismiss="modal" @click="closePopup"/>
          </div>
          <div v-if="termsOfStatus === 'sass'">
              <div class="modal-title">{{ $t('termsAndConditionsText') }}</div>
              <div class="col-sm-12 col-xs-12 col-md-12 pl-24 hr-line">
                <hr/>
              </div>
          </div>
          <div v-if="termsOfStatus === 'termsOfUse'">
              <div class="modal-title">{{ $t('paymentTermsText') }}</div>
              <div class="col-sm-12 col-xs-12 col-md-12 pl-24 hr-line">
                <hr/>
              </div>
          </div>
          <div v-if="termsOfStatus === 'privacyPolicy'">
              <div class="modal-title">{{ $t('privacyNoticeText') }}</div>
              <div class="col-sm-12 col-xs-12 col-md-12 pl-24 hr-line">
                <hr/>
              </div>
          </div>
        </div>
        <div class="modal-body">
            <div v-if="termsOfStatus === 'sass'" class="sass">
              <terms-and-conditions v-if="this.$i18n.locale === 'English'"></terms-and-conditions>
              <terms-and-conditions-portuguese v-else></terms-and-conditions-portuguese>
          </div>
          <div v-if="termsOfStatus === 'termsOfUse'">
              <payment-terms v-if="this.$i18n.locale === 'English'"></payment-terms>
              <payment-terms-portuguese v-else></payment-terms-portuguese>
          </div>
          <div v-if="termsOfStatus === 'privacyPolicy'">
              <privacy-notice v-if="this.$i18n.locale === 'English'"></privacy-notice>
              <privacy-notice-portuguese v-else></privacy-notice-portuguese>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import PaymentTerms from './PaymentTerms.vue';
import TermsAndConditions from './TermsAndConditions.vue';
import PrivacyNotice from './PrivacyNotice.vue';
import PaymentTermsPortuguese from './PaymentTermsPortuguese.vue';
import TermsAndConditionsPortuguese from './TermsAndConditionsPortuguese.vue';
import PrivacyNoticePortuguese from './PrivacyNoticePortuguese.vue';

export default {
  data() {
    return {
      headerText: '',
      termsStatus: '',
    };
  },
  props: ['termsOfStatus'],
  components: {
    TermsAndConditions,
    PaymentTerms,
    PrivacyNotice,
    PaymentTermsPortuguese,
    TermsAndConditionsPortuguese,
    PrivacyNoticePortuguese
  },
  methods: {
    closePopup() {
      $('#agreements').modal('hide');
      $('#agreements .modal-body').scrollTop(0);
    },
  },
  created() {
  },
};
</script>

<style scoped>
p{
  font-size: 14px !important;
  color: #333333 !important;
}
.termsOfUse-modal-dialog .modal-footer{
  background-color: #fff;
  border-radius: 8px;
  border-top: 0px;
  padding-left: 24px;
  padding-right: 24px;
}
.termsOfUse-modal-dialog .modal-body{
  padding: 0px;
  min-height: 40vh;
  max-height: 70vh;
  overflow-y: scroll;
}

.modal-body::-webkit-scrollbar {
  width: 6px;
}
.modal-body::-webkit-scrollbar-thumb {
  background: #D9D9D9;
  border-top-left-radius: 18px;
  border-bottom-left-radius: 18px;
}
.modal-body::-webkit-scrollbar-track-piece:end {
  margin-bottom: 20px;
}
.pb-16{
  padding-bottom: 16px;
}
  .pl-82{
    padding-left: 82px;
  }
  .pl-67{
    padding-left: 67px;
  }
  .pl-70{
      padding-left: 70px;
  }
  .pt-24{
      padding-top: 24px;
  }
  .pt-4{
      padding-top: 4px;
  }
  .pr-8{
      padding-right: 8px;
  }
    .pb-24{
      padding-bottom: 24px;
    }
    .pl-48{
      padding-left: 48px;
    }
    .pr-48{
      padding-right: 48px;
    }
    .pl-16{
      padding-left: 16px;
    }
    .pt-43{
      padding-top: 43px;
    }
    .pl-19{
      padding-left: 19px;
    }
    .pt-16{
      padding-top: 16px;
    }
    .pr-64{
      padding-right: 64px;
    }
    .pb-31{
      padding-bottom: 31px;
    }
    .pb-34{
      padding-bottom: 34px;
    }
    .modal-open .modal{
      overflow: hidden;
    }
    .termsOfUse-modal-dialog .modal-content{
      background-color: #FFFFFF;
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
      border-radius: 3px;
    }
    .termsOfUse-modal-dialog .modal-header{
      padding: 0px;
      background-color: #FFFFFF;
      border: none !important;
    }
    .termsOfUse-modal-dialog .modal-title{
      font-family: 'Open Sans';
      font-style: normal;
      font-weight: 600;
      font-size: 20px;
      color: #1A1A1A;
      padding: 16px 0px 16px 16px;
    }
    .termsOfUse-modal-dialog .hr-line{
      padding-right: 0px;
      padding-left: 0px;
    }
    .termsOfUse-modal-dialog .hr-line hr {
      margin: 0px 0 20px 0;
      border-top: 1px solid #D3D3D3;
    }
    .termsOfUse-modal-dialog .close-icon-section{
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding-top: 24px;
      padding-right: 24px;
      position: absolute;
      right: 0px;
    }
    .close-icon-section img{
      cursor: pointer;
    }
    .termsOfUse-modal-dialog .modal-body .body-text{
      font-family: 'Open Sans';
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 19px;
      color: #333333;
    }
    .sub-title-text-section{
      font-weight: 700;
    }
    p.sub-title-text-section{
      font-size: 14px;
      color: #333333;
    }
    .sub-title-text-section ul{
      margin: 0px;
    }
    .sass .sub-title-text-section ul li{
      list-style-type: none;
      display: flex;
    }
    .termsOfUse-modal-dialog .footer-line{
      padding: 0px 0px 23px 0px;
    }
    .termsOfUse-modal-dialog .footer-line hr{
      border-top: 0.5px solid rgba(0, 0, 0, 0.12);
      margin: 0px;
    }
    .footer-btn{
      float: right;
      padding-right: 22px;
    }
    .termsOfUse-modal-dialog .blue-outline-back-button,
    .termsOfUse-modal-dialog .blue-outline-back-button:hover,
    .termsOfUse-modal-dialog .blue-outline-back-button:focus {
      background-color: #FFFFFF;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid #000000;
      line-height: 25px;
      color: #000000;
      font-size: 18px;
      font-weight: 600;
      border-radius: 5px;
      box-shadow: 4px 4px 10px rgb(0 0 0 / 25%) !important;
      padding: 10px 47px 9px 46px;
      margin: 0px;
  }
  </style>
